<template>
  <div>
    <BancoEntryDialog></BancoEntryDialog>
    <v-text-field v-model="search" append-icon="mdi-database-search" label="Buscar"></v-text-field>
    <v-data-table
      :headers="headers"
      :items="entrys"
      :loading="loading"
      :search="search"
      class="elevation-1"
      :no-data-text="$t('messages.not_result', { item: 'bancos' })"
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-page-first',
        lastIcon: 'mdi-page-last',
        prevIcon: 'mdi-chevron-left',
        nextIcon: 'mdi-chevron-right',
      }"
    >
      <v-progress-linear slot="progress" indeterminate color="blue lighten-2"></v-progress-linear>
      <template v-slot:item.action="{ item }">
        <v-icon color="teal" small class="mr-2" @click="edit(item)">mdi-playlist-edit</v-icon>
        <v-icon color="pink" small @click="remove(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex"
import BancoEntryDialog from "@/components/banco/EntryDialog"

export default {
  name: "reportes-entry",
  components: {
    BancoEntryDialog,
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("common.id"),
          value: "id",
          align: "center",
          width: 100,
        },
        {
          text: this.$t("common.code"),
          value: "codigo",
        },
        {
          text: this.$t("common.name"),
          value: "nombre",
        },
      ],
      loading: true,
      search: "",
    }
  },
  computed: {
    ...mapGetters("Auth", ["role"]),
    ...mapState("Bancos", ["entrys"]),
  },
  mounted() {
    this.getEntry().then(() => {
      this.loading = false

      if (this.role === this.$store.state.TypeRole.ADMINISTRADOR) {
        this.headers.push({
          text: 'ACCIONES',
          value: "action",
          sortable: false,
          width: 1,
        })
      }
    })
  },
  methods: {
    ...mapActions("Bancos", ["getEntry", "deleteEntry"]),
    ...mapMutations("Bancos", ["toggleEntrysDialog"]),
    edit(entry) {
      let editItem = JSON.parse(JSON.stringify(entry));
      this.toggleEntrysDialog({ editMode: true, entry: editItem })
    },
    remove(entry) {
      this.$swal({
        title: this.$t("dialog.title"),
        text: this.$t("dialog.text", { item: entry.nombre }),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("dialog.confirmButtonText"),
        cancelButtonText: this.$t("dialog.cancelButtonText"),
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.deleteEntry(entry)
          this.$swal(
            this.$t("dialog.successTitle"),
            this.$t("dialog.successText"),
            "success",
          )
          return
        }

        this.$swal(
          this.$t("dialog.cancelTitle"),
          this.$t("dialog.cancelText"),
          "info"
        )
      })
    },
  },
}
</script>
